import "./List.css";

import { OrganisationPermissionConstants } from "../../../../../constants";
import { useAuth } from "../../../../../useAuth";
import { Button, Column, CursorDataGrid, Row } from "../../../../../widget";
import { useList } from "./useList";

export const List = (): JSX.Element => {
  const { hasPermission } = useAuth();
  const { dataGridColumns, isLoading, onDataGridChange, onNewUserClick } = useList();
  const canManageOrganisationUsers = hasPermission(OrganisationPermissionConstants.WRITE_ORGANISATION_USERS);
  return (
    <div className="TemplateTabCard ">
      <Row spacingV="ll">
        <Column span={12}>
          <div className="SettingsUserListHeader">
            <h2>Users</h2>
            {canManageOrganisationUsers && <Button text="New User" onClick={onNewUserClick} corners="rounded" />}
          </div>
        </Column>
      </Row>
      <CursorDataGrid
        columns={dataGridColumns}
        clientSide={false}
        filterable
        onChange={onDataGridChange}
        data={[]}
        dataIsLoading={isLoading}
        noDataMessage="No users to display"
        variant="seed"
        hasTotalRow
      />
    </div>
  );
};
